import React, {Fragment} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'
import {Field} from 'formik'
import {TextField} from 'formik-material-ui'

import MaskField from '../../../../components/MaskField'
import SelectField from '../../../../components/SelectField'
import {StepHeader} from '../../styles'

const Step1 = () => {
    return (
        <Fragment>
            <Grow mountOnEnter in timeout={500}>
                <StepHeader>
                    <Typography
                        component="h5"
                        variant="h5"
                        gutterBottom
                        color="textPrimary">
                        Vamos criar seu pré-cadastro!
                    </Typography>
                    <Typography
                        component="p"
                        variant="body1"
                        gutterBottom
                        color="textPrimary">
                        Sua vida vai ficar mais simples, sem burocracia nem papelada.
                    </Typography>
                </StepHeader>
            </Grow>
            <Grow mountOnEnter in timeout={900}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Field
                            name="name"
                            label="Qual é o seu nome completo?"
                            helperText="Como está escrito na sua identidade"
                            fullWidth
                            component={TextField}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            fullWidth
                            name="email"
                            type="email-address"
                            component={TextField}
                            label="Digite o seu e-mail"
                            helperText="Vamos entrar em contato a partir dele"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            label="Como conheceu o Sistema Paralelo?"
                            native
                            name="known"
                            component={SelectField}
                        >
                            <option aria-label="None" value="" />
                            <option value={1}>Indicação de Amigo</option>
                            <option value={2}>Instagram do Sistema Paralelo</option>
                            <option value={3}>YouTube do Sistema Paralelo</option>
                            <option value={4}>Site do Sistema Paralelo</option>
                            <option value={5}>Outros</option>
                        </Field>
                        />
                    </Grid>
                </Grid>
            </Grow>
        </Fragment>
    )
}

export default Step1
